export interface EthnicityOption {
  label: string;
  keywords?: string[];
}

export const ETHNICITY_OPTIONS: EthnicityOption[] = [
  {
    label: "Asian",
    keywords: ["asian", "oriental"],
  },
  {
    label: "Black / African Descent",
    keywords: ["black", "african", "african american", "afro", "afro-caribbean", "afro-latino"],
  },
  {
    label: "Caribbean",
    keywords: ["caribbean", "west indian", "jamaican", "haitian", "trinidadian", "bahamian", "barbadian"],
  },
  {
    label: "Caucasian / White",
    keywords: ["white", "caucasian", "european", "slavic", "celtic", "germanic", "nordic", "anglo"],
  },
  {
    label: "Central Asian",
    keywords: ["central asian", "kazakh", "uzbek", "afghan", "tajik", "turkmen", "kyrgyz"],
  },
  {
    label: "East Asian",
    keywords: ["east asian", "chinese", "japanese", "korean", "taiwanese", "mongolian"],
  },
  {
    label: "Hispanic / Latino / Latina",
    keywords: ["hispanic", "latino", "latina", "latinx", "spanish", "mexican", "puerto rican", "colombian", "cuban", "dominican"],
  },
  {
    label: "Indigenous / Native American",
    keywords: ["indigenous", "native american", "first nations", "american indian", "alaska native", "aboriginal", "inuit"],
  },
  {
    label: "Jewish",
    keywords: ["jewish", "ashkenazi", "sephardi", "mizrahi"],
  },
  {
    label: "Middle Eastern / North African",
    keywords: ["middle eastern", "north african", "mena", "arab", "persian", "iranian", "turkish", "kurdish", "berber", "egyptian", "lebanese"],
  },
  {
    label: "Mixed / Multiracial",
    keywords: ["mixed", "multiracial", "biracial", "bi-racial", "multi-racial", "two or more races"],
  },
  {
    label: "Pacific Islander / Native Hawaiian",
    keywords: ["pacific islander", "native hawaiian", "polynesian", "micronesian", "melanesian", "samoan", "tongan", "fijian"],
  },
  {
    label: "South Asian",
    keywords: ["south asian", "indian", "pakistani", "bangladeshi", "sri lankan", "nepali", "desi"],
  },
  {
    label: "Southeast Asian",
    keywords: ["southeast asian", "filipino", "vietnamese", "thai", "indonesian", "malaysian", "cambodian", "laotian", "burmese"],
  },
  {
    label: "Other",
    keywords: ["other", "different", "custom"],
  },
  {
    label: "Prefer not to say",
    keywords: ["prefer not to say", "none", "skip", "private", "decline", "prefer not to disclose"],
  },
];

export const ALL_ETHNICITIES: string[] = ETHNICITY_OPTIONS.map((e) => e.label);

export const searchEthnicities = (query: string): string[] => {
  const q = query.trim().toLowerCase();
  if (!q) return ALL_ETHNICITIES;
  return ETHNICITY_OPTIONS.filter((item) => {
    if (item.label.toLowerCase().includes(q)) return true;
    if (item.keywords && item.keywords.some((k) => k.toLowerCase().includes(q))) return true;
    return false;
  }).map((item) => item.label);
};
